export default {
  title: 'Crop image',
  targetSize: 'Size after saving is {{width}}x{{height}}px',
  originalSize: 'Original size is {{width}}x{{height}}px',
  cancel: 'Cancel',
  submit: 'Save',
};
